import PropTypes from 'prop-types';

import styling from '../../../services/styling';
import IconSvg from '../../IconSvg';

const CaretRight = ({ color, height, width, ...rest }) => (
  <IconSvg
    {...rest}
    color={color}
    height={height}
    viewBox="0 0 14 21"
    width={width}
  >
    <g fill="currentColor">
      <polygon points="2.98073787 0 0.5 2.47627734 8.53844209 10.5 0.5 18.5237227 2.98073787 21 13.5 10.5" />
    </g>
  </IconSvg>
);

CaretRight.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

CaretRight.defaultProps = {
  color: styling.colors.theme.pureWhite,
  height: 21,
  width: 14,
};

export default CaretRight;
